import React, { useState, useEffect, useContext } from "react";
import {
  getSuppliers,
  getTax,
  getRawMaterials,
  createBulkPurchase,
  getPurchase,
  getPurchaseorderDetail,
  getInvoiceNumber,
  postGeneralData,
  SupplierPurchaseDetails,
  getUnits,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  getFormattedCurrentDate,
  getFormattedCurrentDate2,
  onReqCreatePayment,
  shop_id,
  validateDates,
  warehouse_id,
} from "../../../Utility/function";
import "./dropdown.css";
import {
  InputField,
  NewCommonCardUi,
  SelectOption,
} from "../../Common/CommonCard";
import SupplierForm from "../Suppliers/form";
import { useNavigate } from "react-router-dom";
import PaymentModal from "../../Common/PaymentModal";
import CashModal from "../SalesWindow/modal/CashModal";
import CashCardModal from "../SalesWindow/modal/CashCardModal";
import CardModal from "./modal/CardModal";

const AddPurchase = () => {
  const navigate = useNavigate();
  const { selectedWarehouse, showLoader, hideLoader, shopItem, UserItem, parentCompany } = useContext(WarehouseContext);
  const [taxes, setTax] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [filteredRawMaterials, setFilteredRawMaterials] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([])
  const [supplier, setSupplier] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [SupplierId, setSupplierId] = useState(0);
  const [unqui, setunqui] = useState();
  const [supplierdata, setsupplierData] = useState();
  const [rawMaterialData, setRawMaterialData] = useState();
  const [AuthUser] = useState(UserItem);
  const [discount, setDiscount] = useState(0);
  const [vat, setVat] = useState(0);
  const [freightCharges, setFreightCharges] = useState(0);
  const [otherCharges, setOtherCharges] = useState(0);
  const [previousDue, setPreviousDue] = useState(0);
  const [PurchaseOrder, setPurchaseOrder] = useState([]);
  const [PO, setPO] = useState(false);
  const [isUpdate, setIsUpdate] = useState("1");
  const [inputValue, setInputValue] = useState("");
  const [SupplierValue, setSupplierValue] = useState("");
  const [isSupplierFocused, setIsSupplierFocused] = useState(false);
  const [rows, setRows] = useState([]);
  const [showSupplierModal, setshowSupplierModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [input, setInput] = useState("");
  const [cashShow, setCashShow] = useState(false);
  const [cardShow, setCardShow] = useState(false);
  const [cashCardShow, setCashCardShow] = useState(false);
  const [SupplierBalance, setSupplierBalance] = useState()

  useEffect(() => {
    fetchSuppliers();
    fetchTax();
    fetchPurchaseOrder();
    fetchInvoiceNumber();
    fetchUnitsList();
  }, []);

  // useEffect(() => {
  //   if (!selectedWarehouse?.id) {
  //     toast.warning("Select a Warehouse before Entry");
  //   }
  //   fetchRawMaterials();
  // }, [selectedWarehouse]);
  useEffect(() => {
    fetchRawMaterials();
  }, []);

  const fetchInvoiceNumber = async () => {
    try {
      const response = await getInvoiceNumber(1);
      if (response.data && response.data.invoice_no) {
        setunqui(response.data.invoice_no);
      }
    } catch (error) {
      console.error("Error fetching invoice number:", error);
    }
  };

  const fetchTax = async () => {
    try {
      const response = await getTax();
      if (response.data && response.data.data) {
        setTax(response.data.data);
      } else {
        toast.error("No Tax found.");
      }
    } catch (error) {
      console.error("Error fetching Tax:", error);
      toast.error("Error fetching Tax");
    }
  };

  const fetchUnitsList = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setUnitsList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };

  const fetchPurchaseOrder = async (page = 1, text = "") => {
    try {
      const response = await getPurchase(page, text, 2, shop_id);
      if (response.data && response.data.data) {
        setPurchaseOrder(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
      toast.error("Error fetching purchase orders");
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchRawMaterials = async () => {
    try {
      const response = await getRawMaterials();
      if (response.data && response.data.data) {
        setRawMaterials(response.data.data);
        setFilteredRawMaterials(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
    }
  };

  const fetchSupplierData = async (id) => {
    const res = await SupplierPurchaseDetails(id, shop_id)
    const totalRemaining = res.data.data.reduce((sum, item) => sum + parseFloat(item.remaining || 0), 0);
    setSupplierBalance(totalRemaining)
    setPreviousDue(totalRemaining)
  }

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
  };

  const handleAddRow = () => {

    const requiredFields = [
      "raw_mat_id",
      "qty",
      "purchase_price",
      "unit_id",
    ];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      toast.error(
        `Please fill out the following fields: ${missingFields.join(", ")}`
      );
      return;
    }

    const isProductDuplicate = rows.some(
      (row) => row.raw_mat_id === formData.raw_mat_id
    );

    if (isProductDuplicate) {
      toast.error("This product is already added.");
      return;
    }
    const newRow = {
      id: rows.length + 1,
      raw_mat_id: formData.raw_mat_id,
      supplier_id: formData.supplier_id,
      qty: formData.qty,
      unit_id: formData.unit_id,
      warehouse_id: selectedWarehouse?.id,
      raw_material_name: rawMaterialData?.title || "",
      item_code: rawMaterialData?.product_code || "",
      purchase_price: formData.purchase_price,
      total_amount: formData.total_amount,
      manufactured_date: rawMaterialData?.type == "1" ? "" : formData.manufactured_date,
      expiry_date: rawMaterialData?.type == "1" ? "" : formData.expiry_date,
      purchase_unit: formData.purchase_unit,
      tax_type: formData.tax_type,
      warranty: formData.warranty,
      shop_id: shopItem?.shop_id || "0",
    };

    setRows([...rows, newRow]);

    // Reset form
    setformData({
      ...formData,
      raw_mat_id: "",
      supplier_id: formData.supplier_id,
      purchase_price: "",
      qty: "",
      unit_id: "",
      total_amount: "",
      manufactured_date: "",
      expiry_date: "",
      warranty: "",
      warehouse_id: selectedWarehouse?.id,
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
    });
    setInputValue("");
    setRawMaterialData("");
  };

  const [formData, setformData] = useState({
    warehouse_id: selectedWarehouse?.id,
    invoice_date: new Date().toISOString().split("T")[0],
    purchase_unit: "",
    tax_type: "",
    raw_mat_id: "",
    supplier_id: "",
    purchase_price: "",
    unit_id: "",
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
    qty: "",
    total_amount: "",
    manufactured_date: "",
    expiry_date: "",
    lpo_no: "",
    warranty: ""
  });

  const handleRawMaterialChange = async (value) => {
    setInputValue(value);

    if (value === "") {
      setFilteredRawMaterials(rawMaterials.filter(item => item.status != 2));
    } else {
      const filtered = rawMaterials.filter(material =>
        material.status != 2 && material.title?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredRawMaterials(filtered);
    }
  };

  const handleSupplierChange = (index, value) => {
    setSupplierValue(value);

    if (value === "") {
      setFilteredSuppliers(supplier.filter(item => item.status != 2));
    } else {
      const filtered = supplier.filter(supplier =>
        supplier.status != 2 && supplier.full_name?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }
  };

  const handleSubmit = async (type = "1") => {
    showLoader();
    try {
      const totals = getTotal();
      const grandTotal = totals.grandTotal?.toFixed(3);
      const subTotal = totals.sub_total?.toFixed(3);

      const inputAmount = parseFloat(input || grandTotal);

      let pendingAmount = "0";
      let paidAmount = grandTotal;
      let purchase_type = "1";

      if (type == "2") {
        // Credit purchase
        paidAmount = "0";
        pendingAmount = grandTotal;
        purchase_type = "2";
      } else if (inputAmount < parseFloat(grandTotal)) {
        // Partial payment
        paidAmount = inputAmount.toFixed(3);
        pendingAmount = (parseFloat(grandTotal) - inputAmount).toFixed(3);
        purchase_type = "2";
      }

      console.log("Payment calculation:", {
        grandTotal,
        inputAmount,
        paidAmount,
        pendingAmount,
        type
      });

      // Validate before proceeding
      if (rows.length <= 0) {
        toast.error("Add item before add purchase order");
        hideLoader();
        return;
      }

      if (!SupplierId) {
        toast.error("Required supplier");
        hideLoader();
        return;
      }

      // Prepare payment data
      const paydata = {
        orderID: unqui,
        date: getFormattedCurrentDate2(),
        amount: paidAmount,
        total_amount: grandTotal,
        cash: 0,
        credit: 0,
        card: 0,
        type: 1,
        mop: type == "1" ? "1" : type === "2" ? "2" : type === "4" ? "4" : type === "5" ? "1,4" : "0",
        complete: "0",
      };

      if (type == "1") { // Cash
        if (pendingAmount != "0" && parseFloat(pendingAmount) > 0) {
          paydata.cash = paidAmount;
          paydata.credit = pendingAmount;
          paydata.card = "0";
          paydata.mop = "1,2";
          purchase_type = "2";
        } else {
          paydata.cash = paidAmount;
          paydata.credit = "0";
          paydata.card = "0";
          paydata.mop = "1";
          purchase_type = "1";
          paydata.complete = "1";
        }
      } else if (type == "2") { // Credit
        paydata.cash = "0";
        paydata.credit = grandTotal;
        paydata.card = "0";
        paydata.mop = "2";
        purchase_type = "2";
      } else if (type == "4") { // Card
        if (pendingAmount != "0" && parseFloat(pendingAmount) > 0) {
          paydata.cash = "0";
          paydata.credit = pendingAmount;
          paydata.card = paidAmount;
          paydata.mop = "2,4";
          purchase_type = "2";
        } else {
          paydata.cash = "0";
          paydata.credit = "0";
          paydata.card = paidAmount;
          paydata.mop = "4";
          purchase_type = "1";
          paydata.complete = "1";
        }
      } else if (type == "5") { // Cash + Card
        purchase_type = "1";
        paydata.complete = "1";
        if (pendingAmount != "0" && parseFloat(pendingAmount) > 0) {
          paydata.cash = paidAmount;
          paydata.credit = "0";
          paydata.card = pendingAmount;
          paydata.mop = "1,4";
        } else {
          paydata.cash = paidAmount;
          paydata.credit = "0";
          paydata.card = "0";
          paydata.mop = "1";
        }
      }

      // Prepare purchase rows
      let purchaseRows = rows;
      if (discount) {
        const dis = parseFloat(discount || 0) / 100;
        purchaseRows = rows.map(item => ({
          ...item,
          discount: dis * parseFloat(item.purchase_price || 0)
        }));
      }

      // Prepare save object
      const saveObject = {
        user_id: AuthUser?.user_id || "",
        supplier_id: SupplierId,
        data: JSON.stringify(purchaseRows),
        po_id: unqui,
        sub_total: subTotal,
        lpo_no: formData.lpo_no || "",
        discount: discount || "0",
        vat: vat || "0",
        freight_charges: freightCharges || "0",
        other_charges: otherCharges || "0",
        previous_due: previousDue || "0",
        total: totals.total?.toFixed(3),
        round_off: totals.roundOff?.toFixed(3),
        grand_total: grandTotal,
        balance: totals.balance?.toFixed(2),
        shop_id: shopItem?.shop_id || "0",
        branch_id: parentCompany?.id || "0",
        ware_id: selectedWarehouse?.id || "0",
        created_by: UserItem?.user_id || "0",
        purchase_unit: purchase_type,
        sales_remaining: purchase_type == "2" ? grandTotal : "0",
        amount: paidAmount,
        update_check: isUpdate,
      };

      console.log("Save object:", saveObject);
      console.log("Payment data:", paydata);

      const response = await createBulkPurchase(saveObject);

      if (response?.data.status === "success") {
        try {
          await onReqCreatePayment(paydata);
        } catch (paymentError) {
          console.error("Payment creation failed:", paymentError);
        }

        // General ledger transactions are automatically recorded by the backend service on create.

        hideLoader();
        toast.success("Raw Material Purchase added successfully");
        navigate(-1);
      } else {
        hideLoader();
        toast.error(response?.data?.message || "Failed to create purchase");
      }
    } catch (error) {
      hideLoader();

      const errData = error?.response?.data;

      if (errData?.status === "error" && errData?.required_amount) {
        toast.error(
          `Insufficient bank balance.\n` +
          `Required: ${Number(errData.required_amount).toLocaleString()}\n` +
          `Available: ${Number(errData.available_balance).toLocaleString()}`
        );
        return;
      }

      if (error.response?.data?.errors) {
        error.response.data.errors.forEach((err, index) => {
          toast.error(`Error in row ${index + 1}: ${err.message}`);
        });
      } else {
        console.error("Error:", error);
        toast.error(
          error?.response?.data?.message ||
          "Error saving Order: Something went wrong"
        );
      }
    }
  };


  const closeModal = () => {
    setshowSupplierModal(false);
  };

  const calculateWarrantyMonths = (manufactured_date, expiry_date) => {
    if (!manufactured_date || !expiry_date) return "";

    const mDate = new Date(manufactured_date);
    const eDate = new Date(expiry_date);

    if (isNaN(mDate.getTime()) || isNaN(eDate.getTime()) || eDate <= mDate) {
      return "";
    }

    const yearDiff = eDate.getFullYear() - mDate.getFullYear();
    const monthDiff = eDate.getMonth() - mDate.getMonth();
    const dayDiff = eDate.getDate() - mDate.getDate();

    let months = yearDiff * 12 + monthDiff;

    if (dayDiff < 0) {
      return `${months + 1}`;
    } else if (dayDiff === 0) {
      return `${months}`;
    } else {
      return `${months + 1}`;
    }
  };

  const [maxwarranty, setMaxWarranty] = useState()

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseInt(value);

    if (name === "warranty" && numericValue > maxwarranty) {
      return;
    }

    setformData({ ...formData, [name]: value });

    if (name == "supplier_id") {
      fetchSupplierData(value)
    }

    if (name === "manufactured_date" || name === "expiry_date") {
      const manufacturedDate = name === "manufactured_date" ? value : formData.manufactured_date;
      const expiryDate = name === "expiry_date" ? value : formData.expiry_date;
      const warranty = calculateWarrantyMonths(manufacturedDate, expiryDate);
      setMaxWarranty(warranty)

      setformData((prev) => ({
        ...prev,
        [name]: value,
        warranty: warranty,
      }));
      return;
    }

    if (name === "raw_mat_id") {
      setInputValue(e.target?.raw_name);
      setFilteredRawMaterials([]);
    }

    if (name === "tax_type") {
      setVat(taxes.find((item) => item.id == value)?.value || 0);
    }

    if (name === "supplier_id") {
      setSupplierValue(e.target?.pro_name);
      setFilteredSuppliers([]);
    }

    if (name === "purchase_price") {
      setformData({
        ...formData,
        ["total_amount"]: formData.qty * value,
        [name]: value,
      });
    } else if (name === "qty") {
      setformData({
        ...formData,
        ["total_amount"]: (formData.purchase_price || 0) * value,
        [name]: value,
      });
    }
  };

  const handlecancel = () => {
    setformData({
      ...formData,
      purchase_unit: "",
      tax_type: "",
      raw_mat_id: "",
      supplier_id: "",
      purchase_price: "",
      unit_id: "",
      qty: "",
      total_amount: "",
      manufactured_date: "",
      expiry_date: "",
      lpo_no: "",
      warranty: ""
    });
    setInputValue("");
    setRawMaterialData();
    setsupplierData("");
    setSupplierValue("");
  };

  const fields = (
    <>
      <div className="row">
        {/*<div className="col-lg-4 col-12">
           <div className="card p-3" style={{ minHeight: "105px" }}>
            {SelectOption(
              "Purchase Type",
              "purchase_unit",
              formData.purchase_unit,
              handleChange,
              "Select Purchase",
              [
                {
                  title: "Cash",
                  id: "1",
                },
                {
                  title: "Credit",
                  id: "2",
                },
              ]
            )}
            {SelectOption(
              "Tax Type",
              "tax_type",
              formData.tax_type,
              handleChange,
              "Select Tax",
              taxes
            )}
            {InputField(
              "L.P.O NO.",
              "lpo_no",
              "text",
              formData.lpo_no,
              handleChange,
              "Enter L.P.O NO",
              12
            )}
          </div> 
        </div>*/}
        <div className="col-lg-4 col-12">
          <div className="card mb-0 p-3">
            <div className={`form-group mb-2  d-flex align-items-center`}>
              <label className="col-4 text-verysmall">Supplier</label>
              <div
                className="searchable-dd w-100 d-flex"
                style={{ maxHeight: "1rem" }}
              >
                <input
                  type="text"
                  className="text-small w-100"
                  value={SupplierValue}
                  height={"1.5rem"}
                  onChange={(e) => handleSupplierChange(0, e.target.value)}
                  onFocus={() => {
                    setFilteredSuppliers(supplier.filter(item => item.status != 2));
                    setIsSupplierFocused(true);
                  }}
                  onBlur={() => {
                    setTimeout(() => {
                      setIsSupplierFocused(false);
                    }, 200);
                  }}
                  placeholder="Search Supplier"
                  required
                />
                <button
                  className="btn btn-primary btn-sm d-flex align-items-center justify-content-center ms-2"
                  style={{ width: "20px", height: "22px" }}
                  onClick={() => setshowSupplierModal(true)}
                >
                  <span style={{ fontSize: "18px" }}>+</span>
                </button>
                {(isSupplierFocused || SupplierValue) && filteredSuppliers.length > 0 && (
                  <div className="custom-dropdown">
                    {filteredSuppliers.map((pro) => (
                      <div
                        key={pro.supplier_id}
                        className="dropdown-item"
                        onMouseDown={(e) => {
                          handleChange({
                            target: {
                              name: "supplier_id",
                              value: pro.supplier_id,
                              pro_name: pro.full_name,
                            },
                          });
                          setsupplierData(
                            supplier.find(
                              (item) => item.supplier_id == pro.supplier_id
                            )
                          );
                          setSupplierId(pro.supplier_id);
                          setIsSupplierFocused(false);
                        }}
                      >
                        {pro.full_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {InputField(
              "Address",
              "ref_1",
              "text",
              supplierdata?.address1 || "",
              () => { },
              " ",
              12,
              null,
              undefined,
              undefined,
              true
            )}
            {InputField(
              "Contact no",
              "ref_2",
              "text",
              supplierdata?.phone || "",
              () => { },
              "",
              12,
              null,
              undefined,
              undefined,
              true
            )}
            <div className="d-flex mt-2 column-gap-4">
              {/* <span className="text-small font-weight-2">Balance</span> */}
              <span className="text-small font-weight-2">outstanding/opening Balance</span>
              <span className="text-small font-weight-2">{Number(SupplierBalance).toFixed(2) || 0.0}</span>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 col-12">
          <div className="row-gap-2 d-flex flex-wrap mt-1">
            <div
              className="mx-1 d-flex align-items-center justify-content-center cursor-pointer"
              onClick={() => setPO(true)}
              style={{ width: "100%", height: "55px", background: "green" }}
            >
              <h6 className="text-center text-white m-0">Purchase Order</h6>
            </div>
          </div>
        </div> */}
      </div>
      <div className="col-lg-10 col-12">
        <div className="row">
          <div className={`form-group col-4  d-flex align-items-center`}>
            <label className="col-4 text-verysmall">Raw Material</label>
            <div
              className="searchable-dd  d-flex w-100 mb-2"
              style={{ maxHeight: "1rem" }}
            >
              <input
                type="text"
                className="text-small w-100"
                value={inputValue}
                onChange={(e) => handleRawMaterialChange(e.target.value)}
                placeholder="Search Raw Material"
                required
              />
              {inputValue && filteredRawMaterials.length > 0 && (
                <div className="custom-dropdown">
                  {filteredRawMaterials.map((item) => (
                    <div
                      key={item.id}
                      className="dropdown-item"
                      onClick={(e) => {
                        handleChange({
                          target: {
                            name: "raw_mat_id",
                            value: item.id,
                            raw_name: item.title || "",
                          },
                        });
                        setRawMaterialData(item);
                        setformData(prev => ({
                          ...prev,
                          unit_id: item.type == "1" ? (unitsList.find(u => u.title?.toLowerCase() === "pcs")?.id || "pcs") : (item.unit_id || prev.unit_id)
                        }));
                      }}
                    >
                      {item.title}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Item code",
              "item_code",
              "text",
              rawMaterialData?.product_code || "",
              () => { },
              " ",
              12,
              null,
              undefined,
              undefined,
              true
            )}
          </div>
          <div className="col-4 mt-1 purchase-unit-select-container">
            {SelectOption(
              "Unit",
              "unit_id",
              formData.unit_id,
              handleChange,
              "Select Unit",
              rawMaterialData?.type == "1" ? [
                unitsList.find(u => u.title?.toLowerCase() === "pcs") || { id: "pcs", title: "pcs" },
                unitsList.find(u => u.title?.toLowerCase() === "kg") || { id: "kg", title: "kg" }
              ] : unitsList
            )}
          </div>
        </div>
        <div className="row">
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "QTY",
              "qty",
              "number",
              formData.qty,
              handleChange,
              "Enter Quantity",
              12
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Price",
              "purchase_price",
              "number",
              formData.purchase_price,
              handleChange,
              "Enter Price",
              12
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Total amount",
              "total_amount",
              "number",
              formData.total_amount,
              handleChange,
              "Enter Amount",
              12,
              null,
              null,
              undefined,
              true
            )}
          </div>
        </div>
        {rawMaterialData?.type !== "1" && (
          <div className="row">
            <div className={`form-group col-4 d-flex align-items-center`}>
              {InputField(
                "Manufactured Date",
                "manufactured_date",
                "date",
                formData.manufactured_date,
                handleChange,
                "Enter date",
                12,
                null,
                null,
                getFormattedCurrentDate2(),
                undefined,
                false,
              )}
            </div>

            <div className={`form-group col-4 d-flex align-items-center`}>
              {InputField(
                "Expiry Date",
                "expiry_date",
                "date",
                formData.expiry_date,
                handleChange,
                "Enter date",
                12,
                null,
                null,
                undefined,
                false,
                formData.manufactured_date || getFormattedCurrentDate2()
              )}
            </div>
          </div>
        )}
          {/* <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Warranty (Months)",
              "warranty",
              "number",
              formData.warranty,
              handleChange,Insufficient
              "Enter warranty",
              12,
              null,
              null,
              maxwarranty,
              false,
              1
            )}
          </div> */}
      </div>
      <div className="col-lg-2 col-12 d-flex flex-column row-gap-2">
        <button
          className="btn btn-primary text-small w-75"
          onClick={() => handleAddRow()}
        >
          Add Row
        </button>
        <button
          className="btn btn-secondary text-small w-75"
          onClick={() => handlecancel()}
        >
          Cancel
        </button>
      </div>
    </>
  );

  const getTotal = () => {
    var sub_total = rows.reduce(
      (acc, item) => acc + (parseFloat(item.total_amount) || 0),
      0
    );
    var dis = (sub_total * (discount ? parseFloat(discount) : 0)) / 100;
    var varcount = (sub_total * (vat ? parseFloat(vat) : 0)) / 100;
    var freight = freightCharges ? parseFloat(freightCharges) : 0;
    var other = otherCharges ? parseFloat(otherCharges) : 0;

    var total = sub_total + varcount + freight + other - dis;
    var roundOff = Math.round(total) - total;
    var grandTotal = total + roundOff;
    var balance = (previousDue ? parseFloat(previousDue) : 0) + grandTotal;

    return { sub_total, total, roundOff, grandTotal, balance };
  };

  const GetPurchaseData = async (Purchase) => {
    var res = await getPurchaseorderDetail(Purchase.po);
    var dataList = res.data.data;
    var updatedRawMaterials = [];

    if (dataList.length) {
      setSupplierId(Purchase?.supplier_id);
      setunqui(Purchase?.po);
      setSupplierValue(Purchase?.supplier_name);
      setsupplierData({
        ...supplierdata,
        ["supplier_id"]: Purchase.supplier_id,
        ["address1"]: Purchase.supplier_address,
        ["phone"]: Purchase.supplier_phone,
      });

      updatedRawMaterials = dataList.map((item, index) => ({
        id: index + 1,
        raw_mat_id: item.raw_mat_id || item.product_id,
        supplier_id: Purchase.supplier_id,
        raw_material_name: item.raw_material_name || item.product_name,
        qty: item.qty,
        unit_id: item.unit_id,
        warehouse_id: selectedWarehouse?.id,
        item_code: item.product_code,
        purchase_price: item.purchase_price,
        total_amount: parseFloat(item?.purchase_price || 0) * parseFloat(item?.qty || 0),
        manufactured_date: item.manufactured_date,
        expiry_date: item.expiry_date,
        purchase_unit: item.purchase_unit,
        tax_type: item.tax_type,
        shop_id: shopItem?.shop_id || "0",
      }));
    }

    setRows(updatedRawMaterials);
    setPO(false);
  };

  const handleUpdateRawMaterial = (index, value, name) => {
    const updatedRawMaterials = [...rows];
    updatedRawMaterials[index] = {
      ...updatedRawMaterials[index],
      [name]: value,
    };

    if (name === "purchase_price") {
      updatedRawMaterials[index] = {
        ...updatedRawMaterials[index],
        ["total_amount"]: updatedRawMaterials[index].qty * value,
        [name]: value,
      };
    } else if (name === "qty") {
      updatedRawMaterials[index] = {
        ...updatedRawMaterials[index],
        ["total_amount"]: (updatedRawMaterials[index].purchase_price || 0) * value,
        [name]: value,
      };
    }

    setRows(updatedRawMaterials);
  };

  const handlePaymentType = (type) => {
    if (type == "1") {
      setCashShow(true);
      setInput("");
    } else if (type == "2") {
      handleSubmit(type);
    } else if (type == "5") {
      setCashCardShow(true);
      setInput("");
    } else if (type == "4") {
      setCardShow(true);
      setInput("");
    }
    setShowPayModal(false);
  };

  const handleClick = (value) => {
    setInput((prev) => {
      if (value === ".") {
        if (prev.includes(".") || prev === "") return prev;
      }
      return prev + value;
    });
  };

  const handleBackspace = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  const getAmountDue = () => getTotal().grandTotal?.toFixed(3);

  const getReturnValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue.toFixed(3);

    return input &&
      !isNaN(input) &&
      /^\d+(\.\d{1,2})?$/.test(input) &&
      parseFloat(input) >= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  const getReminingValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue.toFixed(3);

    return input &&
      !isNaN(input) &&
      /^\d+(\.\d{1,2})?$/.test(input) &&
      parseFloat(input) <= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  return (
    <div className="page-content">
      <div className="row mb-2">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3>{unqui}</h3>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary d-flex align-items-center gap-1 py-1 px-3 shadow-sm rounded-1"
            style={{ textTransform: "none" }}
          >
            <i className="bi bi-arrow-left"></i>
            Back
          </button>
        </div>
      </div>

      <NewCommonCardUi feilds={fields} />

      <div className="container-fluid mt-1 px-2">
        <div className="row">
          <div className="card col-10">
            <div className="card-body">
              <div className="d-flex justify-content-end"></div>
              <div className="table-responsive" style={{ minHeight: "500px" }}>
                <table
                  id="example"
                  className="table table-striped table-sm table-bordered"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th className="text-small">S.No</th>
                      <th className="text-small">Raw Material Name</th>
                      <th className="text-small">Item Code</th>
                      <th className="text-small">Unit</th>
                      <th className="text-small">Qty</th>
                      <th className="text-small">Purchase Price</th>
                      <th className="text-small">Total Amount</th>
                      <th className="text-small">Manufactured Date</th>
                      <th className="text-small">Expiry Date</th>
                      {/* <th className="text-small">Warranty</th> */}
                      <th className="text-small">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => {
                      const unitName = unitsList.find(u => u.id == row.unit_id)?.title || row.unit_id || "";
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{row.raw_material_name}</td>
                          <td>{row.item_code}</td>
                          <td>{unitName}</td>
                          <td>
                            <input
                              type="number"
                              name="qty"
                              min={1}
                              value={row.qty}
                              className="w-100"
                              onChange={(e) => {
                                const { name, value } = e.target;
                                handleUpdateRawMaterial(index, value, name);
                              }}
                              style={{ textAlign: "center", minWidth: "75px" }}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              name="purchase_price"
                              min={1}
                              value={row.purchase_price}
                              className="w-100"
                              onChange={(e) => {
                                const { name, value } = e.target;
                                handleUpdateRawMaterial(index, value, name);
                              }}
                              style={{ textAlign: "center", minWidth: "100px" }}
                            />
                          </td>
                          <td>{row.total_amount}</td>
                          <td>{row.manufactured_date}</td>
                          <td>{row.expiry_date}</td>
                          {/* <td>{row.warranty}</td> */}
                          <td>
                            <img
                              src="/assets/images/icons/delete.png"
                              className="m-1"
                              onClick={() => handleRemoveRow(index)}
                              width={"20px"}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-2 p-0 ps-1" style={{ height: "fit-content" }}>
            <div
              className="card py-2 border-black p-1"
              style={{ height: "fit-content" }}
            >
              {InputField(
                "Total",
                "Vat",
                "text",
                getTotal().sub_total.toFixed(2),
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}

              <div
                className={`form-group mb-1 d-flex align-items-end col-${12}`}
              >
                <div className="col-4">
                  <label className="col-12 text-verysmall">{"Discount"}</label>
                  <div className="col-12">
                    <input
                      type={"text"}
                      value={discount}
                      onChange={(e) => {
                        setDiscount(e.target.value);
                      }}
                      className="text-verysmall col-9"
                      style={{ height: "1.5rem" }}
                      placeholder="00.0"
                    />
                    <label className="col-3 text-verysmall">%</label>
                  </div>
                </div>

                <div className="col-8">
                  <input
                    className="w-100 text-verysmall"
                    style={{ height: "1.5rem" }}
                    value={
                      ((rows.reduce(
                        (acc, item) => acc + (parseFloat(item.total_amount) || 0),
                        0
                      ) *
                        (discount ? parseFloat(discount) : 0)) /
                        100).toFixed(2)
                    }
                    disabled={true}
                  />
                </div>
              </div>

              <div
                className={`form-group mb-1 d-flex align-items-end col-${12}`}
              >
                <div className="col-4">
                  {/* <label className="col-12 text-verysmall">{"VAT"}</label> */}
                  <label className="col-12 text-verysmall">{"GST"}</label>
                  <div className="col-12">
                    <input
                      type={"text"}
                      value={vat}
                      onChange={(e) => {
                        setVat(e.target.value);
                      }}
                      className="text-verysmall col-9"
                      style={{ height: "1.5rem" }}
                      placeholder="00.0"
                    />
                    <label className="col-3 text-verysmall">%</label>
                  </div>
                </div>

                <div className="col-8">
                  <input
                    className="w-100 text-verysmall"
                    style={{ height: "1.5rem" }}
                    disabled={true}
                    value={
                      ((rows.reduce(
                        (acc, item) => acc + (parseFloat(item.total_amount) || 0),
                        0
                      ) *
                        (vat ? parseFloat(vat) : 0)) /
                        100).toFixed(2)
                    }
                  />
                </div>
              </div>

              {InputField(
                "Freight Charges  ",
                "freight_charges ",
                "number",
                freightCharges,
                (e) => {
                  setFreightCharges(e.target.value);
                }
              )}
              {InputField(
                "Other Charges  ",
                "other_charges",
                "number",
                otherCharges,
                (e) => {
                  setOtherCharges(e.target.value);
                }
              )}
              {InputField(
                "Previous Due  ",
                "Vat",
                "text",
                previousDue.toFixed(2),
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Grand Total",
                "Vat",
                "text",
                getTotal().grandTotal.toFixed(2),
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Balance",
                "Vat",
                "text",
                getTotal().balance.toFixed(2),
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
            </div>
          </div>
        </div>

        {showSupplierModal && (
          <SupplierForm
            onClose={() => closeModal()}
            fetchSuppliers={fetchSuppliers}
          />
        )}

        <div
          className="fixed-bottom bg-white d-flex justify-content-center py-2 column-gap-3"
          style={{ height: "50px" }}
        >
          <button
            className="btn-primary btn py-0 text-small"
            disabled={rows.length == 0}
            onClick={() => {
              if (!SupplierId) {
                toast.error("Required supplier");
                return;
              } else {
                setShowPayModal(true);
              }
            }}
          >
            Submit
          </button>
        </div>
      </div>

      <div
        className="modal fade show"
        style={{ display: PO ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title">
                {<span className="text-danger">Select Purchase Order</span>}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setPO(false)}
              ></button>
            </div>
            <div className="modal-body p-0">
              <table className="min-w-full m-2 border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border px-2 py-2">Order No</th>
                    <th className="border px-2 py-2">Supplier Name</th>
                    <th className="border px-2 py-2">Date</th>
                    <th className="border px-2 py-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(PurchaseOrder) && PurchaseOrder.length > 0 ? (
                    PurchaseOrder.map((item) => (
                      <tr key={item.id} className="border">
                        <td className="border px-2 py-2">{item?.po}</td>
                        <td className="border px-2 py-2">
                          {item?.supplier_name}
                        </td>
                        <td className="border px-2 py-2">{item?.date}</td>
                        <td className="border px-2 py-2">
                          <button
                            onClick={() => {
                              setIsUpdate("0");
                              GetPurchaseData(item);
                            }}
                            className="bg-primary text-white px-3 py-1 rounded hover:bg-blue-600"
                          >
                            Add
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center p-4">
                        No purchase orders available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="mt-5 ">
                <button
                  type="button"
                  className="btn btn-secondary me-2 float-end"
                  onClick={() => setPO(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PaymentModal
        show={showPayModal}
        onClose={() => setShowPayModal(false)}
        onSelectPayment={handlePaymentType}
      />

      <CashModal
        show={cashShow}
        onClose={() => setCashShow(false)}
        input={input}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handleSubmit}
      />

      <CashCardModal
        show={cashCardShow}
        onClose={() => setCashCardShow(false)}
        input={input}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handleSubmit}
      />

      <CardModal
        show={cardShow}
        onClose={() => setCardShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddPurchase;
